import React from "react";
import "./header.style.sass";
import { Carousel, Icon } from "rsuite";
import logoEn from "../../assets/image/icons/Logo_en.png";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectSlider } from "../../redux/site/site.selector";
import { Setting } from "../../setting";
import CircleLoader from "react-spinners/CircleLoader";
import { css } from "@emotion/react";
import Axios from "axios";

class Header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: "",
		};
	}

	componentDidMount() {
		Axios.get(`${Setting.apiUrl}api/setting/list`).then((res) => {
			this.setState({
				data: res.data,
			});
		});
	}

	render() {
		const { Data } = this.props;
		const { data } = this.state;
		const override = css`
			display: block;
			margin: 40px auto;
			border-color: red;
			position: relative;
			z-index: -1;
		`;
		return (
			<div style={{ direction: "ltr", overflow: "hidden" }}>
				<div className="vid-overlay">
					<div className="vid-text">
						{data ? <h1>{data.header_text}</h1> : null}
					</div>
				</div>
				{Data.length ? (
					<Carousel
						autoplay
						autoplayInterval={Data[0].time * 1000}
						shape={"dot"}
						className="custom-slider"
					>
						{Data.map((vid) => {
							if (vid.type === "video") {
								return (
									<div key={vid.id} className="vid-div">
										<video id={vid.id} autoPlay muted loop>
											<source
												src={`${Setting.apiUrl}/${vid.url}`}
												type="video/mp4"
											/>
										</video>
									</div>
								);
							} else {
								return (
									<div key={vid.id} className="vid-div">
										<img src={`${Setting.apiUrl}/${vid.url}`} />
									</div>
								);
							}
						})}
					</Carousel>
				) : (
					<div className="Header-Loading">
						<CircleLoader css={override} size={285} color="#FF8F3C" />
					</div>
				)}
				<div className="swip-icon">
					<div className="swip-area">
						<Icon icon="chevron-down" />
					</div>
				</div>
			</div>
		);
	}
}
const mapStateToProps = createStructuredSelector({
	Data: selectSlider,
});
export default connect(mapStateToProps)(Header);
